<template>
  <v-app style="background: #eeeeee">
    <v-overlay :value="overlay">
    	<v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <NavAdministration :viewNotificactions="false" />
    <v-main
      v-if="accessAdmin"
      :style="{
        'background-image': 'url(' + require('../../../assets/back2.jpg') + ')',
      }"
    >
      <v-container fluid style="opacity: 1">
        <v-card class="mx-auto">
          <v-card-text class="pb-0">
            <v-alert
              color="primary"
              border="left"
			  dense
              elevation="2"
              colored-border
              icon="mdi-cloud-upload"
            >
              Cargue el archivo excel con las ordenes masivas
            </v-alert>
			<v-row>
				<v-col cols="3">
					<v-checkbox
						v-model="camp_active"
						label="Campaña activa"
						@change="setCampActive()"
					></v-checkbox>
				</v-col>
			</v-row>	
			<v-form ref="form_search_quote">
				<v-row>
					<v-col cols="12" md="3">
						<v-text-field
							v-if="input_camp"
							:rules="ruleCampana"
							prepend-icon="mdi-pencil-box-outline"
							v-model="campDescription"
							color="primary"
							label="Título de la campaña"
							required
						></v-text-field>
						<v-autocomplete
							v-else
							v-model=idCampActive
							:items=campsActives
							item-value="campana_laboratorio_id"
							item-text="descripcion"
						></v-autocomplete>
					</v-col>
					<v-col cols="12" class="col-md-2">
						<v-text-field
							:rules="ruleQuote"
							prepend-icon="mdi-pencil-box-outline"
							append-icon="mdi-magnify"
							v-model="quote"
							color="primary"
							label="Cotización"
							@click:append="searchQuote"
							required
						></v-text-field>
					</v-col>
					<v-col cols="12" class="col-md-2">
						<v-menu
							ref="menu1"
							v-model="menu1"
							:close-on-content-click="false"
							transition="scale-transition"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
									v-model="date"
									label="Fecha de campaña"
									persistent-hint
									prepend-icon="mdi-calendar"
									v-bind="attrs"
									v-on="on"
								></v-text-field>
							</template>
							<v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
						</v-menu>
					</v-col>
					<v-col cols="12" class="col-md-3">
						<v-form ref="form_file">
							<v-file-input
								:disabled="dataQuote.disabledInputFile"
								:rules="ruleFileExcel"
								accept=".xls,.xlsx"
								placeholder="seleccione archivo"
								@change="setFile($event)"
								@click:clear="btnDetailUploadData= true, detailUploadData=false, dataUpload=[], uploadPercent=0"
								prepend-icon="mdi-file-excel"
							></v-file-input>
						</v-form>
					</v-col>
					<v-col cols="12" class="col-md-2 text-center pt-8 pb-2">
						<v-btn
							color="primary"
							small
							title="Descargar formato"
							@click="dowloadFormat"
						>
						<v-icon>mdi-download</v-icon>Formato
						</v-btn>
					</v-col>
				</v-row>
			</v-form>
          </v-card-text>
          <v-col cols="12" class="pt-0">
            <v-simple-table :dense="true" v-if="detailQuote">
				<template v-slot:default>
					<thead>
						<tr>
							<th class="text-left">Número</th>
							<th class="text-left">Cliente</th>
							<th class="text-left">Fecha</th>
							<th class="text-left">Estado</th>
							<th class="text-left">Órdenes</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>{{ dataQuote.quote_id }}</td>
							<td>{{ dataQuote.client }}</td>
							<td>{{ dataQuote.issue_date }}</td>
							<td>{{ dataQuote.description }}</td>
							<td>{{ dataQuote.quantity }}</td>
						</tr>
					</tbody>
				</template>
            </v-simple-table>
            <div>
				<v-alert
					class="text-center"
					dense
					type="info"
					v-if="detailUploadData"
				>
					Datos a cargar
				</v-alert>
				<v-progress-linear
					v-if="detailUploadData"
					v-model="uploadPercent"
					height="25"
					style="pointer-events: none;"
				>
            		<strong color='#fff'>{{ Math.ceil(uploadPercent) }}% CARGADO</strong>
              	</v-progress-linear>
				<div class='text-center my-2' v-if="detailUploadData">TOTAL DE ORDENES: {{dataCompacted.cantidad_ordenes}}</div>
				<v-simple-table :dense="true" v-if="detailUploadData" class="my-2">
					<template v-slot:default>
						<tr>
							<td
								style="border: 1px solid silver"
								class="text-center"
								v-for="(cant, name) in dataCompacted.examenes"
								:key="name"
							>
								<span style="font-size: 11px"><b>{{ name  }}:</b> {{cant}}</span>
							</td>
						</tr>
					</template>
				</v-simple-table>
				<div class='text-center my-2' v-if="detailUploadData">DETALLE</div>
             	<v-simple-table :dense="true" v-if="detailUploadData">
					<template v-slot:default>
						<tr v-for="(item, x) in dataUpload" :key="x">
							<th
								style="border: 1px solid silver"
								class="text-center"
								v-for="(data, y) in item"
								:key="y"
							>
								<span style="font-size: 11px">{{ data }}</span>
							</th>
						</tr>
					</template>
              	</v-simple-table>
				<div class="text-center mt-3">
					<v-btn 
						color="primary" 
						:disabled=btnDetailUploadData
						@click="saveUploadData"
					>
						<v-icon>mdi-content-save</v-icon> Guardar
					</v-btn>
				</div>
            </div>
            <div v-if="failQuote" class="col-md-8 offset-md-2">
              	<v-alert dense type="error" class="text-center">
					{{failQuote}}
				</v-alert>
            </div>
          </v-col>
        </v-card>
      </v-container>
    </v-main>
    <div v-else>No tiene acceso a esta vista</div>
  </v-app>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import NavAdministration from "../../base/NavPrivateComponent";
import axios from "axios";

export default {
  name: "UploadOrdersMassive",
  components: {
    NavAdministration,
  },
  data: () => ({
    file: "",
    quote: null,
    overlay: false,
    detailQuote: false,
    failQuote: false,
	detailUploadData: false,
	btnDetailUploadData:true,
	menu1: false,
	idCampActive:'',
	camp_active:true,
	input_camp:false,
	quoteId:null,
	dataUpload: [],
	dataUploaded : [],
	campDescription:'',
	dataCompacted:[{examenes:[]}],
	campsActives:[],
	uploadPercent: 0,
	date: new Date().toISOString().substr(0, 10),
    dataQuote: {
		client: "",
		description: "",
		issue_date: "",
		quote_id: "",
		disabledInputFile: true,
		quantity: 0
    },
	ruleQuote: [(v) => !!v || "La cotización es requerida"],
	ruleCampana: [(v) => !!v || "el título de la campaña es obligatorio"],
    ruleFileExcel: [(v) => !!v || "El archivo es requerido"],
  }),
  computed: {
    accessAdmin() {
      return (
        typeof this.idActionsRol.find((e) => e === "ACCESO_WEB_ADMIN") !=
        "undefined"
      );
    },
    ...mapState(["idActionsRol", "user", "url", "urlApi", "token"]),
  },
  methods: {
    ...mapMutations(["setUrl"]),

    ...mapActions(["requestApi","alertNotification"]),

    searchQuote() {
      	if (!this.$refs.form_search_quote.validate()) return;

		this.detailQuote = false;
		this.failQuote = false;
		this.overlay = true;
		this.setUrl("carga-ordenes-masivas");
		this.requestApi({
			method: "GET",
			data: {
				quoteId: this.quote,
				idCampActive: this.idCampActive
			},
		}).then((res) => {
			console.log(res)
			this.overlay = false;
			this.quoteId = res.data.quoteId
			if (res.data.dataQuote != null) {
				this.detailQuote = true;
				Object.assign(this.dataQuote, res.data.dataQuote);
			} else {
				this.failQuote = "No existe la cotización ingresada";
				dataQuote.disabledInputFile = true;
			}
		}).catch((err) => {
			this.overlay = false;
		});
    },

    dowloadFormat() {
      this.overlay = true;
      this.setUrl("carga-ordenes-masivas/1");
      this.requestApi({
        method: "PATCH",
        data: {},
      })
        .then((res) => {
          this.overlay = false;
          let link = document.createElement("a");
          link.href = res.data.file;
          link.download = "reporte.xlsx";
          link.click();
        })
        .catch((err) => {
          this.overlay = false;
        });
    },

    setFile(e) {
      if (!this.$refs.form_file.validate()) return;

		this.detailUploadData = false
		this.btnDetailUploadData= true
		this.setUrl("carga-ordenes-masivas");
		let formData = new FormData();
		formData.append("file", e);
		formData.append("view", true);
		formData.append("logued_party_id", this.user.party_id);
		let this2 = this;
		this.uploadPercent = 0
		this.detailUploadData = true
		axios.post(this.url, formData, {
			onUploadProgress: function (progressEvent) {
				if (progressEvent.lengthComputable) {
					let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
					this2.uploadPercent = percentCompleted;
					this2.dataUpload=[]
				}
			},
			headers: {
				"Content-Type": "multipart/form-data",
				Authorization: "Bearer " + this.token,
			},
		}).then((res) => {
			this.dataUploaded = res.data.dataUpload
			this.dataCompacted = res.data.dataCompacted
			this.dataUpload = res.data.arrTable
			this.overlay = false
			this.btnDetailUploadData= false
			this.files = ""
		}).catch((err) => {
			this.detailUploadData = false
			this.uploadPercent=0
			this.overlay = false
			console.log(err)
		})
	},
	
	saveUploadData(){

		this.overlay = true;
		this.setUrl("carga-ordenes-masivas");
		this.requestApi({
			method: "POST",
			data: {
				dataUpload : this.dataUploaded,
				quoteId: this.quoteId,
				view : false,
				logued_party_id: this.user.party_id,
				date : this.date,
				campDescription: this.campDescription,
				idCampActive : this.idCampActive				
			},
		}).then((res) => {
			console.log(res)
			this.quoteId=''
			this.dataUploaded=''
			this.campDescription=''
			this.overlay =false
			this.detailUploadData = false
			this.uploadPercent = 0
			this.btnDetailUploadData= true
			this.alertNotification({
				param:{
					html : res.data.msg
				}																
			})
		}).catch((err) => {
			this.overlay = false;
		});

	},

	getCampaignsActive(){
		
		this.setUrl("carga-ordenes-masivas/1");
		this.requestApi({
			method: "PUT",
			data: {
				sfds:'sdds'
			},
		}).then((res) => {
			this.campsActives = res.data.campsLab
			this.campsActives.unshift({
				campana_laboratorio_id:'',
				descripcion: 'Seleccione'
			})
			console.log(res)
		}).catch((err) => {
			this.overlay = false;
		});


	},

	setCampActive(){
		console.log(this.camp_active)
		if(!this.camp_active) 
			this.idCampActive = ''

		this.input_camp = !this.camp_active
	}

  },
  created(){
	  this.getCampaignsActive()
  }
};
</script>
<style scoped>
	#app > div > main > div > div > div > div.pt-0.col.col-12 > div > div > div > i,
	#app > div > main > div > div > div > div.pt-0.col.col-12 > div > div > div > div {
	position: absolute !important;
	}
</style>